










































import { FormsApi } from "@/api";
import stateMixin from "@/mixins/state";

export default {
  data() {
    return {
      valid: true,
      fields: {
        medicationSet: true
      }
    };
  },
  mixins: [stateMixin],
  name: "RequestOfflineAssortment",
  methods: {
    reset() {
      this.fields = {
        medicationSet: true
      };
    },
    submit: async function() {
      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new FormsApi();
        try {
          const result = await api.formsRequestOfflineAssortment({
            medicationSet: this.fields.medicationSet
          });
          this.setState(this.states.COMPLETED);
          this.reset();
        } catch {
          this.setState(this.states.ERROR);
        }
      }
    }
  }
};
